import { Button, Dropdown, IconButton, Icons } from '@commenda/kakashi';
import { CalendarViewMode } from './calendar.types';

const VIEW_LABELS: Record<CalendarViewMode, string> = {
  month: 'Month',
  agenda: 'Agenda',
};

interface CalendarToolbarProps {
  view: CalendarViewMode;
  label: string;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
  onView: (view: CalendarViewMode) => void;
}

const CalendarToolbar = ({
  view,
  label,
  onPrev,
  onNext,
  onToday,
  onView,
}: CalendarToolbarProps) => {
  return (
    <div className="flex gap-4 items-center shrink-0 pb-3">
      <div className="flex gap-4 items-center">
        <div className="flex gap-2 items-center">
          <IconButton
            size="lg"
            icon={<Icons.ChevronLeft className="size-5" />}
            aria-label="Previous"
            onClick={onPrev}
          />
          <IconButton
            size="lg"
            icon={<Icons.ChevronRight className="size-5" />}
            aria-label="Next"
            onClick={onNext}
          />
        </div>
        <span className="txt-large-bold text-fg-primary whitespace-nowrap">
          {label}
        </span>
      </div>

      <div className="flex flex-1 gap-[10px] items-center justify-end">
        <Dropdown
          align="end"
          menu={{
            groups: [
              {
                items: [
                  { label: 'Month', onClick: () => onView('month') },
                  { label: 'Agenda', onClick: () => onView('agenda') },
                ],
              },
            ],
          }}
        >
          <Button variant="secondary" size="sm">
            {VIEW_LABELS[view]}
            <Icons.ChevronDown className="size-4 text-fg-quaternary" />
          </Button>
        </Dropdown>
        <Button variant="secondary" size="sm" onClick={onToday}>
          Today
        </Button>
      </div>
    </div>
  );
};

export default CalendarToolbar;
